import React from 'react';

const MediaExtra = ({ mediaItem, editedMedia, editMode, isAdmin, canEdit, achievements }) => {
  const type = mediaItem.type.toLowerCase();

  if (type.includes('steamgame') && achievements.length > 0) {
    const completedCount = achievements.filter((ach) => ach.achieved).length;
    const progressPercentage = Math.round((completedCount / achievements.length) * 100);
    const allCompleted = completedCount === achievements.length;

    return (
      <section className={`extra-section ${allCompleted ? 'completed-all' : ''}`}>
        <h2 style={{ display: 'flex', alignItems: 'center' }}>
          <img src="/static/icons/trophy-solid.svg" alt="Achievements" className="section-icon icon" style={{ marginLeft: '8px', height: '25px', width: '25px' }} />
          Achievements ({completedCount}/{achievements.length})
          <span style={{ flex: 1 }}></span> {/* Spacer to push the icon right */}
          {allCompleted && (
            <h2 style={{ margin: 0, padding: 0 }}>
              Perfect Game
              <img src="/static/icons/medal-solid.svg" alt="All Completed" className="section-icon icon" style={{ marginLeft: '8px', height: '50px', width: '50px' }} />
            </h2>
          )}
        </h2>

        <div className="achievement-progress">
          <div className="progress-bar">
            <div className="progress" style={{ width: `${progressPercentage}%` }}></div>
          </div>
          <span className="progress-text">{progressPercentage}% Complete</span>
        </div>
        <hr style={{marginBottom: '20px'}}></hr>
        <div className="achievements-grid">
          {achievements.map((ach) => (
            <div className="achievement-item" key={ach.id}>
              <img
                src={`/static/icons/${ach.achieved ? 'trophy-solid.svg' : 'circle-notch-solid.svg'}`}
                alt={ach.achieved ? 'Achieved' : 'Not Achieved'}
                className="field-icon icon"
              />
              <div className="achievement-details">
                <strong>{ach.name}</strong>
                <p>{ach.description || 'No description available.'}</p>
                {ach.unlock_time && (
                  <span className="unlock-time">
                    Unlocked: {new Date(ach.unlock_time).toLocaleString()}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  } else if (
    (type.includes('anime') || type.includes('animemovie') || type.includes('animeserie') || type.includes('screenmedia')) &&
    mediaItem.seasons?.length > 1
  ) {
    return (
      <section className="extra-section">
        <h2>
          <img src="/static/icons/clapperboard-solid.svg" alt="Seasons" className="section-icon icon" />
          Seasons
        </h2>
        <div className="seasons-grid">
          {mediaItem.seasons.map((season) => (
            <div key={season.id} className="season-card">
              <div className="season-card-details">
                <div className="season-poster-container">
                  <img
                    src={season.image || mediaItem.vertical_image || '/static/images/placeholder.png'}
                    alt={season.title_en || season.title_mal || season.title_tmdb || `Season ${season.id}`}
                    className="season-poster"
                  />
                  {/* {season.description && (
                    <p className="season-description">{season.description}</p>
                  )} */}
                </div>
                <div className="season-content">
                  <div className="season-titles">
                    {season.original_title && (
                      <div className="season-title">
                        <strong>Original:</strong>
                        <span>{season.original_title}</span>
                      </div>
                    )}
  
                    {season.title_tmdb && (
                      <div className="season-title">
                        <strong>TMDB:</strong>
                        <span>{season.title_tmdb}</span>
                      </div>
                    )}
  
                    {season.title_en && (
                      <div className="season-title">
                        <strong>English:</strong>
                        <span>{season.title_en}</span>
                      </div>
                    )}
                    {season.title_mal && (
                      <div className="season-title">
                        <strong>MAL:</strong>
                        <span>{season.title_mal}</span>
                      </div>
                    )}
                    {season.title_ja && (
                      <div className="season-title">
                        <strong>Japanese:</strong>
                        <span>{season.title_ja}</span>
                      </div>
                    )}
                  </div>
                  {(season.genres || season.genre) && (
                    <div className="season-genres">
                      {(season.genres || season.genre?.split(', '))?.map((genre, index) => (
                        <span key={index} className="tag">{genre}</span>
                      ))}
                    </div>
                  )}
                  <div className="season-info">
                    {season.status && (
                      <div className="season-info-item">
                        <strong>Status:</strong> {season.status}
                      </div>
                    )}
                    {(season.current_episode || season.episode_count) && (
                      <div className="season-info-item">
                        <strong>Episodes:</strong> {season.current_episode || 0} / {season.episode_count || '?'}
                      </div>
                    )}
                    {season.season_score && (
                      <div className="season-info-item">
                        <strong>Score:</strong> {season.season_score}
                      </div>
                    )}
                    {season.airing_status && (
                      <div className="season-info-item">
                        <strong>Airing:</strong> {season.airing_status}
                      </div>
                    )}
                    {season.media_type && (
                      <div className="season-info-item">
                        <strong>Type:</strong> {season.media_type}
                      </div>
                    )}
                    {season.studios && (
                      <div className="season-info-item">
                        <strong>Studios:</strong> {season.studios}
                      </div>
                    )}
                    {season.publisher && (
                      <div className="season-info-item">
                        <strong>Publisher:</strong> {season.publisher}
                      </div>
                    )}
                    {season.rating && (
                      <div className="season-info-item">
                        <strong>Rating:</strong> {season.rating}
                      </div>
                    )}
                    {season.mal_score && (
                      <div className="season-info-item">
                        <strong>MAL Score:</strong> {season.mal_score}
                      </div>
                    )}
                    {season.rank && (
                      <div className="season-info-item">
                        <strong>MAL Rank:</strong> {season.rank}
                      </div>
                    )}
  
                    {season.creators && (
                      <div className="season-info-item">
                        <strong>Creators:</strong> {season.creators}
                      </div>
                    )}
  
                    {season.tmdb_score && (
                      <div className="season-info-item">
                        <strong>TMDB Score:</strong> {season.tmdb_score.toFixed(1)}
                      </div>
                    )}
                  </div>
                </div>  
              </div>
              <div>
              {season.description && (
                  <p className="season-description">{season.description}</p>
              )}
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  }
  return null;
};

export default MediaExtra;
